export default [
    {
      path: '/affiliate',
      name: 'affiliate',
      component: () => import('@/views/sft/Affiliate.vue'),
    },
  ]